module.exports = __webpack_public_path__ + "static/img/border2_bottomr.5f9479d8.png";